import { getBusinessType } from '@/constant'

const SMSISACTIVE_ITEMS = ['porsche911', 'porschetaycan']

export function isNeedHandleSMSActive () {
  const unionId = getBusinessType().unionId

  return SMSISACTIVE_ITEMS.includes(unionId)
}